import { useEffect } from 'react';

// Basit body scroll kilidi; modal açıkken dikey kaydırmayı engeller
export function useLockBody(locked: boolean) {
  useEffect(() => {
    const original = document.body.style.overflow;
    if (locked) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = original;
    };
  }, [locked]);
}
